import type Chart from '../../../core/Chart';
import type { Option } from '../../../core/option';
import { normalizeToArray } from '../../../util/utils';
import { DvMarkerModel } from './DvMarkerModel';

function parse(option: Option, chart: Chart) {
  const dvMarkerSeries = normalizeToArray(option.series).filter(
    item => item.type && item.type === 'dvMarker'
  );
  if (dvMarkerSeries.length === 0) {
    return;
  }
  dvMarkerSeries.forEach(seriesItem => {
    seriesItem.type = 'custom';
    seriesItem.dvType = 'dvMarker';
    const dvMarkerModel = new DvMarkerModel(chart, seriesItem, option);
    dvMarkerModel.init();
  });
}

export default {
  type: 'dvMarker',
  parse
};
